import { RASTRO_FEATURE } from './feature';
import { PROVIDERS } from './helpers';
import { registerDashboardRoute, registerRoute } from './routeRegistration';
import {
  ADS_PROVIDER_ROUTE_NAME,
  ADS_ROUTE_NAME,
  ADS_WORKSPACE_ROUTE_NAME,
} from './routeNames';

export {
  ADS_PROVIDER_ROUTE_NAME,
  ADS_ROUTE_NAME,
  ADS_WORKSPACE_ROUTE_NAME,
} from './routeNames';

const LEGACY_WORKSPACE_SECTIONS = new Set([
  'overview',
  'campaigns',
  'conversations',
  'goals',
  'diagnostics',
]);

export const redirectLegacyWorkspaceSection = to => {
  const section = Array.isArray(to.query.section)
    ? to.query.section[0]
    : to.query.section;

  if (!LEGACY_WORKSPACE_SECTIONS.has(section)) return true;

  return {
    name: ADS_WORKSPACE_ROUTE_NAME,
    params: to.params,
    query: to.query,
  };
};

export const redirectLegacyProviderQuery = to => {
  const provider = Array.isArray(to.query.provider)
    ? to.query.provider[0]
    : to.query.provider;

  if (!Object.hasOwn(PROVIDERS, provider)) return true;

  const query = { ...to.query };
  delete query.provider;

  return {
    name: ADS_PROVIDER_ROUTE_NAME,
    params: { ...to.params, provider },
    query,
  };
};

const adsIndexRoute = {
  path: 'ads',
  name: ADS_ROUTE_NAME,
  component: () => import('./views/AdsIntegrationsIndex.vue'),
  beforeEnter: [redirectLegacyWorkspaceSection, redirectLegacyProviderQuery],
  meta: {
    featureFlag: RASTRO_FEATURE,
    permissions: ['administrator'],
  },
};

const adsProviderRoute = {
  path: 'ads/:provider',
  name: ADS_PROVIDER_ROUTE_NAME,
  component: () => import('./views/AdsProviderSetup.vue'),
  props: true,
  meta: {
    featureFlag: RASTRO_FEATURE,
    permissions: ['administrator'],
  },
};

const adsWorkspaceRoute = {
  path: 'rastro',
  name: ADS_WORKSPACE_ROUTE_NAME,
  component: () => import('./views/AdsOverview.vue'),
  meta: {
    featureFlag: RASTRO_FEATURE,
    permissions: ['administrator'],
  },
};

export const routes = [adsWorkspaceRoute];

export const registerAdsRoutes = integrationRoutes => {
  patchIntegrationsCatalog(integrationRoutes);
  const addedProvider = registerRoute(integrationRoutes, adsProviderRoute);
  const addedIndex = registerRoute(integrationRoutes, adsIndexRoute);
  return addedProvider || addedIndex;
};

const patchIntegrationsCatalog = integrationRoutes => {
  const group = integrationRoutes.find(route =>
    route.children?.some(child => child.name === 'settings_applications')
  );
  const indexRoute = group?.children.find(
    child => child.name === 'settings_applications'
  );
  if (!indexRoute || indexRoute.alibsoftRastroCatalog) return;

  indexRoute.component = () => import('./views/IntegrationsCatalog.vue');
  indexRoute.alibsoftRastroCatalog = true;
};

export const registerAdsWorkspaceRoute = dashboardRoutes => {
  return registerDashboardRoute(dashboardRoutes, adsWorkspaceRoute);
};
